import styled from "styled-components";

interface ButtonProps {
  size?: "large" | "default";
}

export const StyledButton = styled("button")<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #2e186a; /* Morado base */
  color: #fff;

  font-size: ${(p) => (p.size === "large" ? "1.5rem" : "1rem")};
  font-weight: 700;
  width: 100%;
  border: none;
  border-radius: 30px;
  padding: ${(p) => (p.size === "large" ? "1rem 2rem" : "0.8rem 1.5rem")};
  cursor: pointer;
  margin-top: 1rem;
  max-width: ${(p) => (p.size === "large" ? "300px" : "180px")};
  transition: all 0.3s ease-in-out;

  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    background-color: rgb(255, 130, 92); /* Naranja en hover */
    color: #fff;
    transform: scale(1.03);
    outline: none;
  }
`;

